import { OrangeButton } from "@/components/Buttons"
import { PlusIcon } from "lucide-react"
import { useNavigate } from "react-router-dom"

export function BottomButtons({project_id}: {project_id: string}) {
    const navigate = useNavigate()

    return (
        <div className="flex justify-end gap-2">
        <OrangeButton onClick={() => navigate(`/projects/upload_file/${project_id}`)}>
            <div className="flex items-center gap-2">
                <PlusIcon className="w-4 h-4" />
                Upload Document
            </div>
        </OrangeButton>
        <OrangeButton onClick={() => navigate(`/projects/upload_proposal/${project_id}`)}>
            <div className="flex items-center gap-2">
                <PlusIcon className="w-4 h-4" />
                Upload Proposal
            </div>
        </OrangeButton>
        <OrangeButton onClick={() => navigate(-1)}>
            Exit
        </OrangeButton>
    </div>      
    )
}
